export const SMALL = 1e-10;
//# sourceMappingURL=constant.js.map
